import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { Chapters } from './components/Chapters';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  return <div className="font-sans bg-gradient-to-b from-blue-50 to-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <Benefits data-id="element-4" />
        <Chapters data-id="element-5" />
        <Testimonials data-id="element-6" />
        <FAQ data-id="element-7" />
        <CallToAction data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}